import { styled } from "@compiled/react";

import { colorCSS, fontSizes, radius } from "../../styles";

const Skip = styled.div({
    ".visually-hidden:not(:focus):not(:active)": {
        "clip": "rect(0 0 0 0)",
        "clipPath": "inset(50%)",
        "clip-path": "inset(50%)",
        "height": "1px",
        "overflow": "hidden",
        "position": "absolute",
        "whiteSpace": "nowrap",
        "white-space": "nowrap",
        "width": "1px"
    },
    "#skip-to-content": {
        "display": "inline-block",
        "padding": "0.5rem 1.25rem",
        "background": colorCSS("N800"),
        "color": colorCSS("N0"),
        "fontSize": fontSizes.sm,
        "border": `1px solid ${colorCSS("N800")}`,
        "borderRadius": radius.button,
        "textDecoration": "none",
        "cursor": "pointer",
        "transition": "all 250ms ease-out",
        "&:hover": {
            background: colorCSS("N400"),
            border: `1px solid ${colorCSS("N400")}`
        },
        "&:focus": {
            outline: `1px solid ${colorCSS("N100")}`
        },
        "&:active": {
            background: colorCSS("N100"),
            border: `1px solid ${colorCSS("N100")}`
        },
        "position": "fixed",
        "top": "0.5rem",
        "left": "0.5rem",
        "zIndex": 1000
    }
});

export default Skip;
